import { AdapterConfiguration, RestAdapter } from '@cundd/rest-adapter';
import { ServiceLocator } from '../ServiceLocator';

export class RestAdapterFactory {

    constructor(private readonly _serviceLocator: ServiceLocator) {
    }

    public get(): RestAdapter {
        const adapterConfiguration = this.buildAdapterConfiguration();

        return new RestAdapter(adapterConfiguration);
    }

    public buildAdapterConfiguration(): AdapterConfiguration {
        const requestSettings: RequestInit = {
            // credentials: 'include',
            // mode: 'no-cors',
            // headers: {'X-Requested-With': 'XMLHttpRequest'}
        };
        if (undefined === process.env.REACT_APP_API_URL) {
            throw new ReferenceError('Missing configuration REACT_APP_API_URL')
        }
        const adapterConfiguration = AdapterConfiguration.fromUrl(
            `${process.env.REACT_APP_API_URL}`,
            requestSettings
        );
        adapterConfiguration.fetchCallback = (input: RequestInfo, init?: RequestInit): Promise<Response> => {
            return fetch(input, init);
        };
        return adapterConfiguration;
    }
}
